"use client";

import { useI18n } from "@/lib/i18n/I18nProvider";

/**
 * UsaliScheduleMock — P&L Schedule S1 (Rooms Department)
 */

export function UsaliScheduleMock() {
  const { t } = useI18n();

  const lines = [
    { i18nKey: "landing.mocks.usali.lineRoomRevenue", actual: "₽4,250,000", budget: "₽4,100,000", variance: "+3.7%", isTotal: false },
    { i18nKey: "landing.mocks.usali.lineCostOfSales", actual: "₽120,000", budget: "₽140,000", variance: "−14.3%", isTotal: false },
    { i18nKey: "landing.mocks.usali.linePayroll", actual: "₽680,000", budget: "₽720,000", variance: "−5.6%", isTotal: false },
    { i18nKey: "landing.mocks.usali.lineOtherExpenses", actual: "₽95,000", budget: "₽100,000", variance: "−5.0%", isTotal: false },
    { i18nKey: "landing.mocks.usali.lineDeptIncome", actual: "₽3,355,000", budget: "₽3,140,000", variance: "+6.8%", isTotal: true },
  ];

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-50 to-white px-6 py-4 border-b border-slate-200">
        <h3 className="text-sm font-bold text-slate-900">
          {t("landing.mocks.usali.title") || "Schedule S1 — Rooms Department"}
        </h3>
        <p className="text-xs text-slate-500 mt-1">
          {t("landing.mocks.usali.period") || "USALI P&L · Апрель 2026"}
        </p>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        {/* Header row */}
        <div className="bg-slate-50 border-b border-slate-200 grid grid-cols-4 gap-4 px-6 py-3">
          <div className="text-xs font-semibold text-slate-600">
            {t("landing.mocks.usali.colLine") || "Статья"}
          </div>
          <div className="text-xs font-semibold text-slate-600 text-right">
            {t("landing.mocks.usali.colActual") || "Факт (₽)"}
          </div>
          <div className="text-xs font-semibold text-slate-600 text-right">
            {t("landing.mocks.usali.colBudget") || "Бюджет (₽)"}
          </div>
          <div className="text-xs font-semibold text-slate-600 text-right">
            {t("landing.mocks.usali.colVariance") || "Откл. (%)"}
          </div>
        </div>

        {/* Data rows */}
        {lines.map((line, i) => (
          <div
            key={i}
            className={`grid grid-cols-4 gap-4 px-6 py-3 items-center ${
              line.isTotal
                ? "bg-keiro-mist/10 border-t-2 border-slate-200 font-bold"
                : i !== lines.length - 1
                ? "border-b border-slate-100"
                : ""
            }`}
          >
            {/* Label */}
            <div className={`text-sm truncate ${line.isTotal ? "text-slate-900 font-bold" : "text-slate-700"}`}>
              {t(line.i18nKey)}
            </div>

            {/* Actual */}
            <div className={`text-sm font-mono text-right ${
              line.isTotal ? "text-slate-900 font-bold" : "text-slate-800"
            }`}>
              {line.actual}
            </div>

            {/* Budget */}
            <div className={`text-sm font-mono text-right ${
              line.isTotal ? "text-slate-700 font-semibold" : "text-slate-600"
            }`}>
              {line.budget}
            </div>

            {/* Variance */}
            <div className={`text-sm font-mono text-right font-semibold ${
              line.variance.startsWith("+")
                ? "text-keiro-green"
                : "text-amber-600"
            }`}>
              {line.variance}
            </div>
          </div>
        ))}
      </div>

      {/* Demo label */}
      <div className="bg-slate-50 border-t border-slate-200 px-6 py-2 text-center">
        <p className="text-xs text-slate-500">
          {t("landing.mocks.usali.demoLabel") || "Демо-режим · реальный UI продукта"}
        </p>
      </div>
    </div>
  );
}
